import $ from 'jquery'

$( document ).on( 'bookwormgb_deal_product_block_output_success', function( e, el ) {
	$( el ).each( function() {
		if( $( this ).find( '.js-countdown' ).length ) {
			// initialization of Countdown
			if ( $.HSCore.components.hasOwnProperty('HSCountdown') ) {
				$.HSCore.components.HSCountdown.init($( this ).find( '.js-countdown' ), {
					yearsElSelector: '.js-cd-years',
					monthElSelector: '.js-cd-months',
					daysElSelector: '.js-cd-days',
					hoursElSelector: '.js-cd-hours',
					minutesElSelector: '.js-cd-minutes',
					secondsElSelector: '.js-cd-seconds'
				})
			}
		}
	})
})